export {default} from './ResetPasswordForm';



// WEBPACK FOOTER //
// ./src/containers/ResetPasswordForm/index.ts